import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { VehicleSettlementSurveyResponseChartData } from "../../types/Chart";

export const getMyEmployerVehicleSettlementSurveyResponseChartData = (
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerVehicleSettlementSurveyResponseChartData"],
    queryFn: (): Promise<VehicleSettlementSurveyResponseChartData> => {
      return fetchWithAuth<VehicleSettlementSurveyResponseChartData>(
        "getMyEmployerVehicleSettlementSurveyResponseChartData"
      );
    },
    enabled: isQueryEnabled(options),
    staleTime: SHORT_STALE_TIME,
  });
};
